// Thin logger wrapper so we have a single place to wire Sentry/Datadog later.
// In development everything goes to the browser console; in production all
// non-error levels are suppressed so customers don't see noise in their devtools.
//
// `error` always logs so production-side incidents stay debuggable on the
// rare occasion a user opens devtools to report something.

const isProd = process.env.NODE_ENV === "production";

function fmt(scope, args) {
    return [`[${scope}]`, ...args];
}

export const logger = {
    debug(scope, ...args) {
        if (isProd) return;
        console.debug(...fmt(scope, args));
    },
    warn(scope, ...args) {
        if (isProd) return;
        console.warn(...fmt(scope, args));
    },
    error(scope, ...args) {
        console.error(...fmt(scope, args));
        // TODO: pipe to Sentry/Datadog once a key is provisioned.
    },
};

export default logger;
